<script setup lang="ts">
import { FindGamesDocument, type FindGamesQuery, type GameListItemFragment } from "../graphql/types"
import { useAsyncEntitySearch } from "../forms/composables/useAsyncEntitySearch"
import AsyncBadgeCombobox from "../forms/components/AsyncBadgeCombobox.vue"

const modelValue = defineModel<GameListItemFragment[]>({ default: () => [] })

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false })

const { items, loading, hasMore, search, loadMore } = useAsyncEntitySearch<FindGamesQuery, GameListItemFragment>({
  queryDocument: FindGamesDocument,
  extract: (r) => r.findGames
})
</script>

<template>
  <AsyncBadgeCombobox
    v-model="modelValue"
    :items="items"
    :loading="loading"
    :has-more="hasMore"
    :search="search"
    :label-fn="(g) => g.name"
    placeholder="Spiel suchen..."
    :disabled="disabled"
    @load-more="loadMore"
  />
</template>
